<template>
  <div class="container-md">
    <div class="col-sm-12" style="display: flex; margin-bottom: 18px;" >
      <alert-comp :key="msgKey" :msg="msgAlert" />
    </div>
    <div class="acoes" v-if="backButtonIsVisible">
      <button class="btn btn-outline-danger" @click.prevent="voltar"> Voltar </button>
    </div>
    <div class="form-group row mt-3">
      <!-- Validação da forma antiga -->
      <div class="col-sm-12">
        <font size="1">
          <p size="1" v-if="errosValidacao.length" class="erro">
            <b size="1">Favor, verificar o(s) campo(s) abaixo:</b>
            <ul size="1">
              <li v-for="erro in errosValidacao" v-bind:key="erro" size="1">
                {{ erro }}
              </li>
            </ul>
          </p>
        </font>
      </div>

      <label class="col-sm-2">Tipo:</label>
      <div class="col-md-4 col-sm-10">
        <select class="mb-3 p-0 form-control" v-model="interessado.tipoContatoExterno" @change="ocultarCampos">
          <option v-for="(item, indice) in tipoInteressados" :key="indice" :value="item.key">{{ item.value }}</option>
        </select>
      </div>

      <label v-show="isPessoaFisica" class="col-sm-2">CPF:</label>
      <div class="col-md-4 col-sm-10" v-show="isPessoaFisica">
        <the-mask v-show="isPessoaFisica" :mask="['###.###.###-##']" type="text" class="form-control"
          :class="{'form-group--error': $v.interessado.cpf.$error}" id="inputCpf" v-model="interessado.cpf"/>
        <div class="error" v-if="!$v.interessado.cpf.required">O campo é obrigatório</div>
        <!-- Validação da forma antiga cpf -->
        <label class="col-md-4 col-sm-10 mb-3 p-0 erro">{{erroValicaoCpf}}</label>
      </div>

      <label v-show="!isPessoaFisica" class="col-sm-2">CNPJ:</label>
      <div class="col-md-4 col-sm-10" v-show="!isPessoaFisica">
        <the-mask v-show="!isPessoaFisica" :mask="['##.###.###/####-##']" type="text" class="form-control" id="inputCnpj"
          v-model="interessado.cnpj"/>
        <div class="error" v-if="!$v.interessado.cnpj.required">O campo é obrigatório</div>
        <!-- Validação da forma antiga cnpj -->
        <label class="col-md-4 col-sm-10 mb-3 p-0 erro">{{erroValicaoCnpj}}</label>
      </div>

      <label class="col-sm-2">Nome:</label>
      <div class="col-md-10 col-sm-10">
        <input type="text" class="form-control" id="inputNome" v-model="interessado.nome"/>
        <div class="error" v-if="!$v.interessado.nome.required">O campo é obrigatório</div>
        <label class="col-md-4 col-sm-10 mb-3 p-0 erro">{{erroValicaoNome}}</label>
      </div>

      <label class="col-sm-2">E-mail:</label>
      <div class="col-md-10 col-sm-10">
        <input type="email" class="form-control" id="inputEmail" v-model="interessado.email"/>
          <label class="col-md-4 col-sm-10 mb-3 p-0 erro"> {{erroValicaoEmail}}</label>
      </div>

      <label class="col-sm-2">CEP:</label>
      <div class="col-md-4 col-sm-10">
        <div class="input-group">
          <the-mask :mask="['#####-###']" type="text" class="form-control" id="inputCEP" v-model="interessado.endereco.cep"/>
          <div class="input-group-append">
            <button class="btn btn-outline-secondary" type="button" @click.prevent="pesquisarCEP">Pesquisar</button>
          </div>
        </div>
        <label class="col-md-4 col-sm-10 mb-3 p-0 erro"> {{erroValicaoCep}}</label>
      </div>

      <label class="col-sm-2">  Estado:</label>
      <div class="col-md-4 col-sm-10 mb-3">
        <input type="text" class="form-control" id="inputEstado" v-model="interessado.endereco.estado"/>
      </div>

      <label class="col-sm-2">Cidade:</label>
      <div class="col-md-4 col-sm-10 mb-3">
        <input type="text" class="form-control" id="inputCidade" v-model="interessado.endereco.cidade"/>
      </div>

      <label class="col-sm-2">Bairro:</label>
      <div class="col-md-4 col-sm-10 mb-3">
        <input type="text" class="form-control" id="inputBairro" v-model="interessado.endereco.bairro"/>
      </div>

      <label class="col-sm-2">Rua:</label>
      <div class="col-md-4 col-sm-10 mb-3">
        <input type="text" class="form-control" id="inputRua" v-model="interessado.endereco.rua"/>
      </div>

      <label class="col-sm-2">Número:</label>
      <div class="col-md-4 col-sm-10 mb-3">
        <input type="number" class="form-control" id="inputNumero" v-model="interessado.endereco.numero"/>
      </div>

      <label class="col-sm-2">Complemento:</label>
      <div class="col-md-4 col-sm-10 mb-3">
        <input type="text" class="form-control" id="inputComplemento" v-model="interessado.endereco.complemento"/>
      </div>

      <label class="col-sm-2">País:</label>
      <div class="col-md-4 col-sm-10 mb-3">
        <input type="text" class="form-control" id="inputPais" v-model="interessado.endereco.pais"/>
      </div>

      <div class="btnAcoes">
        <button class="btn btn-outline-primary" @click.prevent="salvar"> Salvar </button>
      </div>
    </div>
  </div>
</template>

<script>
import InteressadoService from '@/services/InteressadoService'
import LocalidadeService from '@/services/LocalidadeService'
import alertComp from '@/components/alert/AlertComp'
import { required } from 'vuelidate/lib/validators'

export default {
  components: {
    alertComp
  },

  props: {
    backButtonIsVisible: { required: false, type: Boolean, default: true }
  },

  data () {
    return {
      msgAlert: {
        texto: '',
        type: ''
      },
      msgKey: false,
      isPessoaFisica: true,
      tipoInteressados: [
        {
          key: 'PESSOAFISICA',
          value: 'Pessoa Física'
        },
        {
          key: 'PESSOAJURIDICA',
          value: 'Pessoa Juridica'
        }
      ],
      interessado: {
        tipoContatoExterno: 'PESSOAFISICA',
        cpf: '',
        cnpj: '',
        nome: '',
        email: '',
        endereco: {
          cep: '',
          estado: '',
          cidade: '',
          bairro: '',
          rua: '',
          numero: '',
          complemento: '',
          pais: 'Brasil'
        }
      },
      errosValidacao: [],
      erroValicaoCpf: '',
      erroValicaoCnpj: '',
      erroValicaoNome: '',
      erroValicaoEmail: '',
      erroValicaoCep: ''
    }
  },
  validations: {
    interessado: {
      cpf: {
        required
      },
      cnpj: {
        required
      },
      nome: {
        required
      }
    }
  },
  created () {
    this.interessadoService = new InteressadoService()
    this.localidadeService = new LocalidadeService()

    if (this.$route.query.idContatoExterno) {
      this.buscarContatoExterno(this.$route.query.idContatoExterno)
    }
  },

  methods: {

    pesquisarCEP () {
      if (this.interessado.endereco.cep.length !== 8) {
        return false
      }
      this.localidadeService.getLocalidadeByCep(this.interessado.endereco.cep).then(response => {
        this.interessado.endereco.estado = response.estado
        this.interessado.endereco.cidade = response.cidade
        this.interessado.endereco.bairro = response.bairro
      }).catch(err => {
        console.log(err)
        this.msgAlert.texto = 'Erro ao buscar localidade pelo cep'
        this.msgAlert.type = 'danger'
        this.msgKey = !this.msgKey
      })
    },

    mapEndereco (endereco) {
      if (
        endereco.cep === '' &&
        endereco.estado === '' &&
        endereco.cidade === '' &&
        endereco.bairro === '' &&
        endereco.rua === '' &&
        endereco.numero === '' &&
        endereco.complemento === '' &&
        endereco.pais === ''
      ) {
        return null
      }

      for (const key in endereco) {
        if (endereco[key] === '') {
          delete endereco[key]
        }
      }

      return endereco
    },

    salvar () {
      const dadosSessao = this.$store.getters.getDadosSessao
      this.interessado.sessaoUsuario = dadosSessao.sessao
      const interessado = {
        ...this.interessado,
        endereco: this.mapEndereco(this.interessado.endereco)
      }

      if (!this.interessado.id) {
        if (this.validarCampos()) {
          this.interessadoService.novo(interessado).then((response) => {
            this.msgAlert.texto = `Contato (${this.interessado.nome}) salvo com sucesso`
            this.msgAlert.type = 'success'
            this.msgKey = !this.msgKey
            this.limpar()
          }).catch(err => {
            console.log(err)
            const mensagemErro = err.message
            if (mensagemErro.indexOf('422') !== -1) {
              this.msgAlert.texto = `Erro ao salvar contato (${this.interessado.nome}), CPF ou CNPJ já cadastrado no setor`
              this.msgAlert.type = 'danger'
              this.msgKey = !this.msgKey
            } else {
              this.msgAlert.texto = `Erro ao salvar contato (${this.interessado.nome})`
              this.msgAlert.type = 'danger'
              this.msgKey = !this.msgKey
            }
          })
        }
      } else {
        if (this.validarCampos()) {
          this.interessadoService.editar(this.interessado.id, interessado).then((response) => {
            this.msgAlert.texto = `Contato (${this.interessado.nome}) salvo com sucesso`
            this.msgAlert.type = 'success'
            this.msgKey = !this.msgKey
          }).catch(err => {
            this.msgAlert.texto = 'Erro ao atualizar contato'
            this.msgAlert.type = 'danger'
            this.msgKey = !this.msgKey
            console.log(err)
          })
        }
      }
    },

    buscarContatoExterno (idContatoExterno) {
      this.interessadoService.buscarContatoExterno(idContatoExterno).then((response) => {
        const interessado = response.data[0]
        if (!interessado.endereco) {
          interessado.endereco = {
            cep: '',
            estado: '',
            cidade: '',
            bairro: '',
            rua: '',
            numero: '',
            complemento: '',
            pais: ''
          }
        }
        interessado.endereco.cep = interessado.endereco.cep || ''
        interessado.endereco.estado = interessado.endereco.estado || ''
        interessado.endereco.cidade = interessado.endereco.cidade || ''
        interessado.endereco.bairro = interessado.endereco.bairro || ''
        interessado.endereco.rua = interessado.endereco.rua || ''
        interessado.endereco.numero = interessado.endereco.numero || ''
        interessado.endereco.complemento = interessado.endereco.complemento || ''
        interessado.endereco.pais = interessado.endereco.pais || ''
        this.interessado = interessado
        this.ocultarCampos()
      })
    },

    voltar () {
      this.$router.back()
    },

    limpar () {
      this.interessado = {
        ...this.interessado,
        cpf: '',
        cnpj: '',
        nome: '',
        email: '',
        endereco: {
          cep: '',
          estado: '',
          cidade: '',
          bairro: '',
          rua: '',
          numero: '',
          complemento: '',
          pais: 'Brasil'
        }
      }
      this.errosValidacao = []
      this.erroValicaoCpf = ''
      this.erroValicaoCnpj = ''
      this.erroValicaoNome = ''
      this.erroValicaoEmail = ''
      this.erroValicaoCep = ''
    },

    limparMensagemErro () {
      this.msgAlert = undefined
    },

    ocultarCampos () {
      if (this.interessado.tipoContatoExterno === 'PESSOAFISICA') {
        this.isPessoaFisica = true
        this.interessado.cnpj = ''
      } else {
        this.isPessoaFisica = false
        this.interessado.cpf = ''
      }
    },

    validarCampos () {
      this.erroValicaoCpf = ''
      this.erroValicaoCnpj = ''
      this.erroValicaoNome = ''
      this.erroValicaoEmail = ''
      this.erroValicaoCep = ''
      this.errosValidacao = []
      if (this.interessado.tipoContatoExterno === 'PESSOAFISICA') {
        if (this.interessado.cpf !== '' && this.interessado.cpf.length !== 11) {
          this.erroValicaoCpf = '*Cpf deve possuir 11 caracteres.'
          this.errosValidacao.push(this.erroValicaoCpf)
        }
      }

      if (this.interessado.tipoContatoExterno === 'PESSOAJURIDICA') {
        if (this.interessado.cnpj !== '' && this.interessado.cnpj.length !== 14) {
          this.erroValicaoCnpj = '*Cnpj deve possuir 14 caracteres.'
          this.errosValidacao.push(this.erroValicaoCnpj)
        }
      }

      if (this.interessado.endereco.cep && this.interessado.endereco.cep.length !== 8) {
        this.erroValicaoNome = '*CEP deve pussuir 8 caracteres.'
        this.errosValidacao.push(this.erroValicaoNome)
      }

      if (!this.interessado.nome) {
        this.erroValicaoNome = '*Nome requerido.'
        this.errosValidacao.push(this.erroValicaoNome)
      }

      if (!this.emailValido(this.interessado.email) && this.interessado.email !== '') {
        this.erroValicaoEmail = '*E-mail válido requirido.'
        this.errosValidacao.push(this.erroValicaoEmail)
      }

      if (!this.errosValidacao.length) {
        return true
      }
    },

    emailValido (email) {
      if (email) {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return re.test(email)
      }

      return false
    }
  }
}
</script>

<style scoped lang="scss">
.row {
  margin-top: 2px;
}

.acoes {
  .btn {
    margin-right: 10px;
    width: 150px;
    height: 28px;
  }
}
.erro {
  color: orange;
}
</style>
